<template>
    <Modal class="price-edit-modal"
           size="sm"
           :custom-title-text="title"
           icon="fa-coins"
           :cancel="cancel"
           :ok="ok">
        <div class="cash-labels mb-1">
            <div class="alert alert-info cash-label">
                {{ l('PRICE_EDITOR.CURRENT_PRICE') }}
                <h3>{{ currencyFilter(initialPrice) }}</h3>
            </div>
            <div class="alert alert-success cash-label">
                {{ l('PRICE_EDITOR.NEW_PRICE') }}
                <h3 v-if="newPrice !== null">
                    {{ currencyFilter(newPrice) }}
                </h3>
                <h3 v-else
                    style="opacity: .5">
                    {{ currencyFilter(initialPrice) }}
                </h3>
            </div>
        </div>

        <NumPad ref="num-pad"
                v-model="newPrice"
                :allow-null="true"
                :show-decimal-button="true"
                :show-sign-button="true"
                :show-value="false"
                @ok="ok"
                @cancel="cancel"></NumPad>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import NumPad from '@/vue/components/NumPad/NumPad';
import { CloseModalOnEscapeMixin } from '@/vue/mixins/CloseModalOnEscapeMixin';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: {
        NumPad,
        Modal,
    },

    mixins: [
        CloseModalOnEscapeMixin,
        ModalPropsMixin,
    ],

    props: {
        cartLine: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            initialPrice: this.cartLine.getPrice(),
            newPrice: null,
        };
    },

    computed: {
        /**
         * @return {string}
         */
        title() {
            return container.langService.getText('PRICE_EDITOR.MODAL_TITLE')
                + ' '
                + this.cartLine.getName();
        },
    },

    methods: {
        ok() {
            // Only override the default price if it has been changed.
            let priceChanged = false;
            if (this.newPrice !== null && this.newPrice !== this.initialPrice) {
                this.cartLine.customPrice = this.newPrice;
                this.cartLine.setPrice(this.newPrice);
                priceChanged = true;
            }

            this.resolve({
                priceChanged,
                newPrice: this.newPrice,
            });
        },
    },
};
</script>
